import LegalLayout, { H2, P } from "./LegalLayout";

export default function About() {
  return (
    <LegalLayout title="About & Imprint" updated="30 Aug 2026">
      <P>
        <strong>rsell ai</strong> is a resale-intelligence tool for clothing and vintage flippers.
        Point three photos at an item, get an AI-generated pricing report with live market comps,
        listing copy for Depop, eBay and Poshmark, shipping estimates, and a negotiation cheat sheet.
      </P>

      <H2>Operator (EU e-commerce disclosure)</H2>
      <P>
        <strong>Service name:</strong> rsell ai<br />
        <strong>Domain:</strong>{" "}
        <a href="https://rsellai.top" className="text-[#10B981] underline">rsellai.top</a><br />
        <strong>Location:</strong> Lithuania, European Union<br />
        <strong>Contact email:</strong>{" "}
        <a href="mailto:rsell.ai.real@gmail.com" className="text-[#10B981] underline">rsell.ai.real@gmail.com</a><br />
        <strong>Legal entity:</strong> operated as a sole trader — legal registration details available on request<br />
        <strong>VAT number:</strong> not registered (below EU VAT threshold); Whop collects EU VAT at checkout on our behalf
      </P>

      <H2>What we do</H2>
      <P>
        We combine an OpenAI vision model with public eBay market data to help resellers price stock
        faster and list it in one click. Reports are treated as guidance — see the{" "}
        <a href="/terms" className="text-[#10B981] underline">Terms of Service</a> for the full estimate disclaimer.
      </P>

      <H2>Legal &amp; compliance</H2>
      <P>
        <a href="/privacy" className="text-[#10B981] underline">Privacy Policy</a> ·{" "}
        <a href="/terms" className="text-[#10B981] underline">Terms of Service</a> ·{" "}
        <a href="/refund-policy" className="text-[#10B981] underline">Refund Policy</a>
      </P>

      <H2>Report a problem</H2>
      <P>
        For any legal, privacy, or billing issue email{" "}
        <a href="mailto:rsell.ai.real@gmail.com" className="text-[#10B981] underline">rsell.ai.real@gmail.com</a>.
        We reply within two business days on legal matters and within 30 days for GDPR data-rights
        requests (as required by law — we usually respond much faster).
      </P>
    </LegalLayout>
  );
}
